/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );
  
});

$( document ).ready(function() {
    $( ".arrow-down" ).click(function() {
      $( this ).parent().parent().children().children( ".filter-item" ).toggle();
      $( this ).toggle();
      $( this ).parent().children( ".arrow-up" ).toggle();
      $( this ).parent().parent('.tcp-tc-block-container').children( ".tcp-block-content" ).toggle();
    });
    $( ".arrow-up" ).click(function() {
      $( this ).parent().parent().children().children( ".filter-item" ).toggle();
      $( this ).toggle();
      $( this ).parent().children( ".arrow-down" ).toggle();
      $( this ).parent().parent('.tcp-tc-block-container').children( ".tcp-block-content" ).toggle();
    });
    $( "#close-button" ).click(function() {
      $( "#tcp-bar" ).removeClass('showed');
      $( "#size-bar" ).removeClass('showed');
      $( "#tcp-overlay" ).hide();
      $( "#close-button" ).hide();
    });
    $( "#tcp-overlay" ).click(function() {
      $( "#tcp-bar" ).removeClass('showed');
      $( "#size-bar" ).removeClass('showed');
      $( "#tcp-overlay" ).hide();
      $( "#close-button" ).hide();
    });
    $( "#terms-trigger" ).click(function() {
      $( "#tcp-bar" ).addClass('showed');
      $( "#tcp-overlay" ).show();
      $( "#close-button" ).delay(350).fadeIn(150);
    });
    $( "#privacy-trigger" ).click(function() {
      $( "#tcp-bar" ).addClass('showed');
      $( "#tcp-overlay" ).show();
      $( "#close-button" ).delay(350).fadeIn(150);
    });
    $( "#contacts-trigger" ).click(function() {
      $( "#tcp-bar" ).addClass('showed');
      $( "#tcp-overlay" ).show();
      $( "#close-button" ).delay(350).fadeIn(150);
    });
    $( "#size-trigger" ).click(function() {
      $( "#size-bar" ).addClass('showed');
      $( "#tcp-overlay" ).show();
      $( "#close-button" ).delay(350).fadeIn(150);
    });
  	$( ".size-guide-trigger" ).click(function() {
      $( "#size-bar" ).addClass('showed');
      $( "#tcp-overlay" ).show();
      $( "#close-button" ).delay(350).fadeIn(150);
    });
  
  	$( ".label-swatch-color-div" ).click(function() {
      $( ".label-swatch-color-div" ).css( "background-color", "#d8d8d8" );
      $( this ).css( "background-color", "#fff" );
      $( ".label-swatch-color-div" ).css( "border", "1px solid #d8d8d8" );
      $( this ).css( "border", "1px solid #000" );
    });
  
  	$( ".label-swatch-size-div" ).click(function() {
      $( ".label-swatch-size-div" ).css( "background-color", "#d8d8d8" );
      $( this ).css( "background-color", "#fff" );
      $( ".label-swatch-size-div" ).css( "border", "1px solid #d8d8d8" );
      $( this ).css( "border", "1px solid #000" );
    });
  
  	$( "#close-banner" ).click(function() {
      $( "#shopify-section-announcement-bar" ).remove();
    });
 
  	$( "#burger-trigger" ).click(function() {
      $( "#mobile-menu" ).addClass('showed');
    });
  
  	$( "#close-mobile-menu" ).click(function() {
      $( "#mobile-menu" ).removeClass('showed');
    });
  
    $( "#filter-by-mobile" ).click(function() {
      $( ".shop-filters-mobile" ).addClass('showed');
    });
  
    $( "#close-filters-mobile-trigger" ).click(function() {
      $( ".shop-filters-mobile" ).removeClass('showed');
    });
});

$(window).load(function() {
  	$( ".product-item-link-container" ).hover(
      function() {
        $( this ).children( ".hidden-hover-picture" ).show();
      }, function() {
        $( this ).children( ".hidden-hover-picture" ).hide();
      }
    );
  
    const myTimeout = setTimeout(myGreeting, 1000);

    function myGreeting() {
      $("#cart-menu").css("pointer-events", "auto")
    }

  
  	
});